import { Api } from './Swagger'

export class ApiClient {
    static baseUrl: string = process.env.REACT_APP_API_URI ?? "";
    static instance: Api<unknown> = new Api({
        baseUrl: ApiClient.baseUrl,
    });
}